import { z } from 'zod';
import { optionalNullableDateInput, requiredUuidString } from '../zod-helpers/index.js';
/** Hard cap consistent with MAX_SHIP_CARTONS_PER_RECORD precedent. */
export const MAX_SHIP_LINE_ITEMS_PER_REQUEST = 500;
export const shipPurchaseOrderInputSchema = z.object({
    lineItemIds: z
        .array(requiredUuidString('Line item is required.', 'Invalid line item selection.'))
        .min(1, 'At least one line item is required.')
        .max(MAX_SHIP_LINE_ITEMS_PER_REQUEST, 'Too many line items in a single request.')
        .refine((ids) => new Set(ids).size === ids.length, 'Duplicate line item IDs are not allowed.'),
    dateFirstShip: optionalNullableDateInput,
});
//# sourceMappingURL=ship-input.js.map